module.exports = __webpack_public_path__ + "static/img/setting_hover.f4f68b36.svg";